const courses = [
  {
    id: 1,
    name: 'Introduction to React',
    slug: 'intro-to-react',
    category: 'Frontend',
    level: 'Beginner',
    duration: '3 hours',
    lessons: 24,
    language: 'English',
    domain: 'Web Development',
    description: 'Learn the fundamentals of React, components, props, and state.',
    imageUrl:
      'https://images.pexels.com/photos/1181675/pexels-photo-1181675.jpeg?auto=compress&cs=tinysrgb&w=800',
    videoUrl: 'https://www.youtube.com/watch?v=bMknfKXIFA8',
    highlights: [
      'JSX and component structure',
      'Props vs state',
      'Rendering lists and conditional UI',
    ],
  },
  {
    id: 2,
    name: 'Advanced React Patterns',
    slug: 'advanced-react-patterns',
    category: 'Frontend',
    level: 'Advanced',
    duration: '2 hours',
    lessons: 32,
    language: 'English',
    domain: 'Web Development',
    description:
      'Dive into hooks, context, performance optimization, and advanced architectural patterns.',
    highlights: [
      'Custom hooks and composition',
      'Context API for shared state',
      'Performance tuning and memoization',
    ],
    imageUrl:
      'https://images.pexels.com/photos/3861964/pexels-photo-3861964.jpeg?auto=compress&cs=tinysrgb&w=800',
    videoUrl: 'https://www.youtube.com/watch?v=FZ0cG47msEk',
  },
  {
    id: 3,
    name: 'JavaScript Essentials',
    slug: 'javascript-essentials',
    category: 'Programming',
    level: 'Beginner',
    duration: '1.5 hours',
    lessons: 20,
    language: 'English',
    domain: 'Programming Foundations',
    description:
      'Master the core concepts of modern JavaScript used in web development and beyond.',
    highlights: [
      'Variables, functions, and scope',
      'ES6+ syntax and features',
      'Asynchronous JavaScript basics',
    ],
    imageUrl:
      'https://images.pexels.com/photos/1181263/pexels-photo-1181263.jpeg?auto=compress&cs=tinysrgb&w=800',
    videoUrl: 'https://www.youtube.com/watch?v=W6NZfCO5SIk',
  },
  {
    id: 4,
    name: 'Node.js API Development',
    slug: 'node-api-development',
    category: 'Backend',
    level: 'Intermediate',
    duration: '3.5 hours',
    lessons: 28,
    language: 'English',
    domain: 'Backend Development',
    description: 'Build RESTful APIs with Node.js, Express, and a database layer.',
    highlights: [
      'Express routing and middleware',
      'Working with databases',
      'Authentication and best practices',
    ],
    imageUrl:
      'https://images.pexels.com/photos/1181465/pexels-photo-1181465.jpeg?auto=compress&cs=tinysrgb&w=800',
    videoUrl: 'https://www.youtube.com/watch?v=Oe421EPjeBE',
  },
  {
    id: 5,
    name: 'UI/UX Design Basics',
    slug: 'ui-ux-basics',
    category: 'Design',
    level: 'Beginner',
    duration: '2 hours',
    lessons: 16,
    language: 'English',
    domain: 'Product Design',
    description: 'Understand the principles of user experience and modern UI design.',
    highlights: [
      'Designing with user journeys',
      'Visual hierarchy and layout',
      'Wireframing and prototyping',
    ],
    imageUrl:
      'https://images.pexels.com/photos/196645/pexels-photo-196645.jpeg?auto=compress&cs=tinysrgb&w=800',
    videoUrl: 'https://www.youtube.com/watch?v=3o3Bb41mQAE',
  },
  {
    id: 6,
    name: 'Full-Stack Web Project',
    slug: 'full-stack-web-project',
    category: 'Fullstack',
    level: 'Intermediate',
    duration: '4 hours',
    lessons: 30,
    language: 'English',
    domain: 'Full-Stack Development',
    description:
      'Plan, design, and build a complete full-stack web application from scratch.',
    highlights: [
      'Frontend + backend integration',
      'Authentication and authorization',
      'Deployment best practices',
    ],
    imageUrl:
      'https://images.pexels.com/photos/3861972/pexels-photo-3861972.jpeg?auto=compress&cs=tinysrgb&w=800',
    videoUrl: 'https://www.youtube.com/watch?v=nu_pCVPKzTk',
  },
  {
    id: 7,
    name: 'TypeScript for React Developers',
    slug: 'typescript-for-react',
    category: 'Frontend',
    level: 'Intermediate',
    duration: '2.5 hours',
    lessons: 22,
    language: 'English',
    domain: 'Web Development',
    description:
      'Add strong typing to your React projects for safer, more maintainable code.',
    highlights: [
      'TypeScript basics and tooling',
      'Typing props, state, and hooks',
      'Working with external type definitions',
    ],
    imageUrl:
      'https://images.pexels.com/photos/1181670/pexels-photo-1181670.jpeg?auto=compress&cs=tinysrgb&w=800',
    videoUrl: 'https://www.youtube.com/watch?v=Z5iWr6Srsj8',
  },
  {
    id: 8,
    name: 'Data Structures & Algorithms Lite',
    slug: 'dsa-lite',
    category: 'Programming',
    level: 'Intermediate',
    duration: '3 hours',
    lessons: 26,
    language: 'English',
    domain: 'Problem Solving',
    description:
      'Explore the most practical data structures and algorithms used in real projects.',
    highlights: [
      'Arrays, lists, and hash maps',
      'Sorting and searching patterns',
      'Big-O reasoning for real code',
    ],
    imageUrl:
      'https://images.pexels.com/photos/1181533/pexels-photo-1181533.jpeg?auto=compress&cs=tinysrgb&w=800',
    videoUrl: 'https://www.youtube.com/watch?v=8hly31xKli0',
  },
  {
    id: 9,
    name: 'Intro to Cloud & DevOps',
    slug: 'cloud-and-devops-intro',
    category: 'DevOps',
    level: 'Beginner',
    duration: '2 hours',
    lessons: 18,
    language: 'English',
    domain: 'Cloud & Operations',
    description:
      'Get comfortable with cloud concepts, CI/CD pipelines, and basic infrastructure automation.',
    highlights: [
      'Cloud fundamentals',
      'Continuous integration basics',
      'Infrastructure as code overview',
    ],
    imageUrl:
      'https://images.pexels.com/photos/1181671/pexels-photo-1181671.jpeg?auto=compress&cs=tinysrgb&w=800',
    videoUrl: 'https://www.youtube.com/watch?v=mxT233EdY5c',
  },
  {
    id: 10,
    name: 'Product Thinking for Engineers',
    slug: 'product-thinking-engineers',
    category: 'Product',
    level: 'All Levels',
    duration: '1.5 hours',
    lessons: 12,
    language: 'English',
    domain: 'Product & Strategy',
    description:
      'Think beyond code and learn how to design features that deliver real user value.',
    highlights: [
      'User research fundamentals',
      'Defining success metrics',
      'Prioritization and roadmapping',
    ],
    imageUrl:
      'https://images.pexels.com/photos/1181345/pexels-photo-1181345.jpeg?auto=compress&cs=tinysrgb&w=800',
    videoUrl: 'https://www.youtube.com/watch?v=p4JfqPQFq3E',
  },
];

export default courses;


